import { ChangeDetectorRef, Component, ElementRef, Inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { NgxFullscreenDirective } from '@ultimate/ngx-fullscreen';
import { DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/auth/auth.service';
import { MnoMappingComponent } from '../mno-mapping.component';
import { PopupButtonComponent } from 'src/app/shared/components/popup-button/popup-button.component';
import { MnoMappingEditComponent } from '../mno-mapping-edit/mno-mapping-edit.component';
import { MnoMappingService } from '../mno-mapping.service';
import { P } from '@angular/cdk/keycodes';
import { MnoActionsComponent } from '../mno-actions/mno-actions.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { FullscreenService } from 'src/app/fullscreen.service';

@Component({
  selector: 'app-mno-map-model',
  templateUrl: './mno-map-model.component.html',
  styleUrls: ['./mno-map-model.component.scss']
})
export class MnoMapModelComponent implements OnInit {
  @ViewChild('card') card: ElementRef<Element>;
  @ViewChild('fullscreen') fullscreen: NgxFullscreenDirective;
  @ViewChild('newMnoModel') newMnoModel: TemplateRef<any>; // open dialog in same page
  mccInput: string = '';
  mncInput: string = '';
  searchValue: string = '';
  screenHide = false;
  isFullScreen = false;
  context: any;
  separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];
  private gridApi!: GridApi;
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public defaultColDef: ColDef = {
    flex: 1,
    resizable: true,
    cellClass: "vertical-middle"
  }; name: any
  filteredRegions: string[] = [];
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;
 

  public columnDefs: ColDef[] = [
    { headerName: 'Regions', field: '_source.region', minWidth: 65, sortable: true, cellStyle: { textAlign: 'center' }, sort: 'asc' },
    { headerName: 'MNO s', field: '_source.mno', minWidth: 65, sortable: true, cellStyle: { textAlign: 'center' } },

    { headerName: 'MCC', field: '_source.mcc', minWidth: 65, sortable: true, cellStyle: { textAlign: 'center' } },
    { headerName: 'MNC', field: '_source.mnc', minWidth: 65, sortable: true, cellStyle: { textAlign: 'center' } },


    {
      headerName: '4G Bands', field: '_source.band_4g', minWidth: 65, sortable: true, cellStyle: { textAlign: 'center' },
      cellRenderer: (params: any) => {
        const data = params.data._source.band_4g?.map((item) => {
          return "<span class='badge bg-dark rounded-pill ml-1 text-wrap' style='color: #200101 !important; font-size: 12px !important'> " + item + "</span>"
        })
        return data.length > 0 ? "<span class='text-wrap' >" + data.join(' ') + "</span>" : '-';
      }
    },
    {
      headerName: '5G Bands', field: '_source.band_5g', minWidth: 65, sortable: true, cellStyle: { textAlign: 'center' },
      cellRenderer: (params) => {
        const data = params.data._source.band_5g?.map((item) => {
          return "<span class='badge bg-dark rounded-pill ml-1 text-wrap' style='color: #200101 !important; font-size: 12px !important'> " + item + "</span>"
        })
        return data.length > 0 ? "<span class='text-wrap' >" + data.join(' ') + "</span>" : '-';
      }
    },
    {
      headerName: 'NSA 5G bands', field: '_source.band_nsa_5g', minWidth: 65, sortable: true, cellStyle: { textAlign: 'center' },
      cellRenderer: (params) => {
        const data = params.data._source.band_nsa_5g?.map((item) => {
          return "<span class='badge bg-dark rounded-pill ml-1 text-wrap' style='color: #200101 !important; font-size: 12px !important'> " + item + "</span>"
        })
        return data?.length > 0 ? "<span class='text-wrap' >" + data.join(' ') + "</span>" : '-';
      }
    },

    {
      headerName: 'Actions', field: 'actions', cellStyle: { textAlign: 'center' },
      cellRenderer: MnoActionsComponent
    }
  ];
  public rowData: any[]
  mapData = []
  floorMapData: any;
  selectedRows: any[];
  matDialogRef: MatDialogRef<MnoMappingEditComponent>;
  selectedId: any;
  error: string;
  selectedData: any;
  subscription: any;
  newMno = {
    region: '',
    mno: '',
    mcc: [],
    mnc: [],
    bands4G: [],
    bands5G: [],
    bandsNsa5G: []
  };
  uniqueError: string;
  errormessage: string;
  enableSaveButton: boolean;
  regionsArray: any;
  isEditMode = false;
  previousMno: any;
  constructor(public dialogRef: MatDialogRef<MnoMapModelComponent>, @Inject(DOCUMENT) private document: any, @Inject(MAT_DIALOG_DATA) public props: any,
    private modalService: NgbModal, private cdr: ChangeDetectorRef,private fullscreenService: FullscreenService, 
    private mnomapService: MnoMappingService, private authService: AuthService, private matDialog: MatDialog, private toastrService: ToastrService,
  ) {
    this.subscription = this.authService.refreshdataany.subscribe(x => {
      this.refreshData();
    })
  }
  elem;
  ngOnInit(): void {
    this.elem = document.documentElement;
    this.getAllMnos();
    this.getRegionData();
    this.context = {
      componentParent: this
    }

    document.addEventListener('fullscreenchange', () => {
      this.isFullScreen = !!document.fullscreenElement;
    });
  }
  closePopup() {
    this.dialogRef.close();
  }
  refreshData() {
    setTimeout(() => {
      this.getAllMnos();
    }, 2000);
  }
  getAllMnos() {
    this.mnomapService.getMnoBandDetails().subscribe((response: any) => {
      this.rowData = response.result.hits;
    })
  }
  onFilterTextBoxChanged() {
    this.gridApi.setQuickFilter(
      (document.getElementById('filter-text-box') as HTMLInputElement).value
    );
  }
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
  }
  clearSearch() {
    this.searchValue = '';
  }
  onSelectionChanged(event) {
    this.selectedRows = this.gridApi.getSelectedRows();
  }

  deleteRecord() {
    if (this.selectedRows.length == 1) {
      this.selectedId = this.selectedRows[0]._id
      this.mnomapService.deleteMnoExisting(this.selectedId).subscribe((response: any) => {
      })
    }
  }
  openFullscreen(event) {
    this.fullscreenService.openFullscreen('child');
    this.fullscreen.enter(this.card.nativeElement);
    this.screenHide = true;
    // this.tableHeight = event.target.innerHeight - 100;
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.webkitRequestFullscreen) { /* Safari */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) { /* IE11 */
      this.elem.msRequestFullscreen();
    }
  }
  closeFullscreen() {
    this.fullscreenService.closeFullscreen();
    this.screenHide = !this.screenHide;
    if (document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      this.document.msExitFullscreen();
    }
  }

   // Add code to the corresponding array
   addCode(type: 'mcc' | 'mnc', event: MatChipInputEvent): void {
    const input = event.input // Retrieve the input element
    const value = (event.value || '').trim();

    if (value && !isNaN(Number(value))) {
      this.newMno[type].push(Number(value)); // Add the number to the array
    }

    // Clear the input field
    if (input) {
      input.value = '';
    }
  }

  // Remove a code from the array
  removeCode(type: 'mcc' | 'mnc', code: number): void {
    const index = this.newMno[type].indexOf(code);
    if (index >= 0) {
      this.newMno[type].splice(index, 1);
    }
  }
  handlePaste(type: 'mcc' | 'mnc', event: ClipboardEvent): void {
    const clipboardData = event.clipboardData?.getData('text');
    if (clipboardData) {
      // Split the pasted text into an array by commas or spaces
      const values = clipboardData.split(/[\s,]+/);
  
      // Filter and add only valid numeric values
      values.forEach(value => {
        const trimmedValue = value.trim();
        if (trimmedValue && !isNaN(Number(trimmedValue)) && !this.newMno[type].includes(Number(trimmedValue))) {
          this.newMno[type].push(Number(trimmedValue));
        }
      });
    }
  
    // Prevent the default paste behavior (e.g., inserting the text into the input field)
    event.preventDefault();
  }
  addBand(type: string, event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Convert value to a number and ensure it is valid
    const numberValue = Number(value);

    if (!isNaN(numberValue) && numberValue > 0) {  // Only add positive numbers
      this.newMno[`bands${type}`].push(numberValue);
    }
    if (input) {
      input.value = '';
    }
    this.enablesubmitButtonsmethod();
    this.cdr.detectChanges();

  }

  removeBand(type: string, band: string): void {
    const index = this.newMno[`bands${type}`].indexOf(band);
    if (index >= 0) {
      this.newMno[`bands${type}`].splice(index, 1);
    }
    this.enablesubmitButtonsmethod();
  }

  pasteBands(type: string, event: ClipboardEvent): void {
    event.preventDefault();
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData?.getData('text') || '';

    pastedText
      .split(',')
      .map(band => band.trim())
      .filter(band => band)
      .forEach(band => this.newMno[`bands${type}`].push(band));
  }
  // Handle form submission
  createNewMno() {
    const obj = {
      band_4g: this.newMno.bands4G,
      band_5g: this.newMno.bands5G,
      band_nsa_5g: this.newMno.bandsNsa5G,
      mcc: this.newMno.mcc,
      mnc: this.newMno.mnc,
      mno: this.newMno.mno,
      region: this.newMno.region,
      isTemporary: true
    }
    if (this.isEditMode) {
      this.mnomapService.updateMnoExisting(obj, this.selectedId).subscribe((res) => {
        this.getAllMnos();
        setTimeout(() => {
          this.getAllMnos();
        }, 2000);
        this.closeModal();
        this.isEditMode = false;
      })
    } else {
      this.mnomapService.createNewMno(obj).subscribe((res) => {
        this.getAllMnos();
        setTimeout(() => {
          this.getAllMnos();
        }, 2000);
        this.closeModal();

      })
    }

  }
  closeModal() {
    this.isEditMode = false;
    this.newMno.region = '';
    this.newMno.bands4G = [];
    this.newMno.bands5G = [];
    this.newMno.bandsNsa5G = [];
    this.newMno.mno = '';
    this.newMno.mcc = [];
    this.newMno.mnc = [];
    this.mccInput = '';	
      this.mncInput = '';
    this.modalService.dismissAll(); // Closes the modal
  }
  allowOnlyNumbers(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'Tab', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight', 'Delete', 'space'];
    if (allowedKeys.indexOf(event.key) !== -1) {
      return; // Allow these keys
    }
    // Prevent non-numeric characters
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }
  newMnoChange() {
    this.enablesubmitButtonsmethod();
  }
  OpenMNOAddPopup(newMno) {
    this.modalService.open(newMno, { ariaLabelledBy: 'modal-basic-title', windowClass: "width-400 custom-modal-zindex", backdrop: 'static',
      keyboard: false }).result.then(
    )
  }

  enablesubmitButtonsmethod() {
    let uniqueness;
    const mnoList = this.rowData.filter((item) => {
      return item._source.region == this.newMno.region.trim();
    })
    if (this.isEditMode) {
      // Find and remove the previous MNO based on the index or unique identifier
      const previousMnoIndex = mnoList.findIndex(
        (mno) => mno._id === this.selectedId
      );
      if (previousMnoIndex !== -1) {
        mnoList.splice(previousMnoIndex, 1);
      }
    }
    const obj = mnoList.filter((item) => {
      if (this.newMno.mno) {
        return item._source.mno == this.newMno.mno.trim()
      } else {
        return;
      }
    });
    if (obj.length > 0) {
      this.uniqueError = `${this.newMno.mno} already exists`
      uniqueness = false;
    } else {
      uniqueness = true;
      this.uniqueError = '';
    }
    if (this.newMno.bands4G && this.newMno.bands4G.length > 0 || this.newMno.bands5G && this.newMno.bands5G.length > 0 || this.newMno.bandsNsa5G && this.newMno.bandsNsa5G.length > 0) {

      this.errormessage = '';
    } else {
      this.errormessage = 'Please select at least one type of bands';
    }
    if (uniqueness && this.newMno.mno && (this.newMno.bands4G.length > 0 || this.newMno.bands5G.length > 0 || this.newMno.bandsNsa5G.length > 0)) {

      this.enableSaveButton = false
    } else {
      this.enableSaveButton = true
    }
  }
  selectCountry(country: string): void {
    this.newMno.region = country;
    this.filteredRegions = []; // Clear the dropdown
  }
  newRegionChange(value: string) {
    this.filteredRegions = this.regionsArray.filter(region =>
      region.toLowerCase().includes(value.toLowerCase())
    );
    this.enablesubmitButtonsmethod();

  }
  openEditPopup(rowData: any) {
    this.isEditMode = true;
    this.selectedId = rowData._id;
    this.newMno.region = rowData._source.region;
    this.newMno.mno = rowData._source.mno;
    this.previousMno = rowData._source.mno;
    this.newMno.mcc = rowData._source.mcc;
    this.newMno.mnc = rowData._source.mnc;
    this.newMno.bands4G = rowData._source.band_4g;
    this.newMno.bands5G = rowData._source.band_5g;
    this.newMno.bandsNsa5G = rowData._source.band_nsa_5g;
    this.modalService.open(this.newMnoModel, { ariaLabelledBy: 'modal-basic-title', windowClass: "width-400 custom-modal-zindex ",  backdrop: 'static',
      keyboard: false, }).result.then(
    )
  }
  getRegionData() {
    this.mnomapService.getRegions().subscribe((response: any) => {
      this.regionsArray = response.map(item => item.name ? item.name : []);
      this.filteredRegions = this.regionsArray;
    })
  }
 
  }

